import {Component, Input, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material';
import {Grievance} from '../../_services/_modals/grievance.modal';
import {MainService} from '../../_services/main.service';
import {UtilService} from '../../../common/_services/util.service';
import {HttpService} from '../../../common/_services/http.service';
import {ActivatedRoute} from '@angular/router';
import {AppEventService} from '../../../common/_services/event-broadcaster.service';
import {GrievanceService} from '../../_services/grievance.service';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-casemanager',
  templateUrl: './casemanager.component.html',
  styleUrls: ['./casemanager.component.css'],
})
export class CasemanagerComponent implements OnInit {
  mod_callerid: string;
  ai_id: any;
  user_role: string;
  grievances_array: Grievance[] = [];
  item = [];
  mnews_ai: string;
  assigned: any;
  unassigned: any;

  constructor(private mainService: MainService,
              private utilService: UtilService,
              private httpService: HttpService,
              private route: ActivatedRoute,
              public routea: ActivatedRoute,
              private broadcastService: AppEventService,
              private grievanceService: GrievanceService) {
    this.routea.queryParams.subscribe(data => {
      this.ai_id = data['ai_id'];
      this.mod_callerid = data['mod_callerid'];
      this.user_role = data['user_role'];
    });
  }

  async ngOnInit() {
    this.get_grievances(3);
  }
    get_grievances(grievance_state) {
        let grievanceService = null;
        let items;
        this.item = [];
        if (grievance_state === 3) {
            grievanceService = this.grievanceService.getGrievanceByNumber(this.ai_id, grievance_state, '91' + this.mod_callerid);
        } else {
            grievanceService = this.grievanceService.getGrievanceByNumber(this.ai_id, grievance_state, '91' + this.mod_callerid);
        }
        grievanceService.subscribe(async value => {
            this.grievances_array = value.result;
            for (let item of this.grievances_array) {
                let items_array = item.item_id;
                this.item.push(items_array);
                this.mnews_ai = JSON.parse(item.mnews_ai);
            }
            if (this.grievances_array.length > 0) {
                this.item = this.item.slice(0, 20);
                items = await this.httpService.getBatchData(this.item, this.mnews_ai, 0);
            }
            items.Responses.Items = this.orderItemList(items.Responses.Items);
            if (grievance_state === 3) {
                if (items) {
                    this.assigned = new MatTableDataSource(items.Responses.Items);
                }
                this.get_grievances(4);
            } else if (grievance_state === 4 && items) {
                this.unassigned = new MatTableDataSource(items.Responses.Items);
            }
        });
    }

    orderItemList(itemList) {
        return itemList.sort(function(a,b) {
            return Date.parse(b.time) - Date.parse(a.time)
        });
    }
}
